import { Component, OnInit, ComponentFactoryResolver } from '@angular/core';
import { DomSanitizer } 		from '@angular/platform-browser';
import { MatIconRegistry } 	from '@angular/material/icon';
import { Router, ActivatedRoute }				from '@angular/router';
import { HostListener } from '@angular/core';

import { Globals } from '../Globals'
declare let ga: any;

import {AuthenticationService}  from  './_services/authentication.service';
import storage from 'local-storage-fallback';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
	public user;
	title = 'imt-pm-app';
	appClass;
	courseDetaiID=0;
	elearningEnrollID=0;
	loadMycourse=false;
	showMainMenu;
	constructor(
		public globals: Globals,
		private resolver: ComponentFactoryResolver, 
		private iconRegistry: MatIconRegistry, 
		private sanitizer: DomSanitizer, 
		private router: Router, 
		private route: ActivatedRoute,
		private authenticationService: AuthenticationService){

		
		iconRegistry.addSvgIcon('done',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/done.svg'));
	    iconRegistry.addSvgIcon('thumbs-up',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/thumb-up.svg'));
	    iconRegistry.addSvgIcon('thumbs-down',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/thumb-down.svg'));
	    iconRegistry.addSvgIcon('account',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/account.svg'));
	    iconRegistry.addSvgIcon('play',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/play.svg'));
	    iconRegistry.addSvgIcon('search',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/search.svg'));
	    iconRegistry.addSvgIcon('setting',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/setting.svg'));
	    iconRegistry.addSvgIcon('list',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/list.svg'));
	    iconRegistry.addSvgIcon('star',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/star.svg'));
	    iconRegistry.addSvgIcon('star-half',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/star_half.svg'));
	    iconRegistry.addSvgIcon('star-empty',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/star_empty.svg'));

	    /*Course Detail Icon*/
	    iconRegistry.addSvgIcon('list-alt',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/list-alt.svg'));
	    iconRegistry.addSvgIcon('certificate',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/certificate.svg'));
	    iconRegistry.addSvgIcon('play',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/play.svg'));
	    iconRegistry.addSvgIcon('verify',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/verify.svg'));
	    iconRegistry.addSvgIcon('web',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/web.svg'));
	    iconRegistry.addSvgIcon('mobile',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/mobile.svg'));
	    iconRegistry.addSvgIcon('business',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/business.svg'));
	    iconRegistry.addSvgIcon('help',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/help.svg'));
	    iconRegistry.addSvgIcon('clock',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/clock.svg'));
	    iconRegistry.addSvgIcon('caption',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/caption.svg'));

    	iconRegistry.addSvgIcon('play-arrow',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/play-arrow.svg'));
    	iconRegistry.addSvgIcon('pause',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/pause.svg'));
			iconRegistry.addSvgIcon('skip-next',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/skip-next.svg'));
			iconRegistry.addSvgIcon('chevron-right',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/chevron_right.svg'));
			iconRegistry.addSvgIcon('chevron-left',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/chevron_left.svg'));
			iconRegistry.addSvgIcon('chevron-down',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/chevron_down.svg'));
			iconRegistry.addSvgIcon('clear',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/clear.svg'));
			iconRegistry.addSvgIcon('timer',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/timer.svg'));
			iconRegistry.addSvgIcon('fullscreen',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/fullscreen.svg'));
			iconRegistry.addSvgIcon('fullscreen-out',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/fullscreen-out.svg'));
			iconRegistry.addSvgIcon('play-circle-outline',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/play-circle-outline.svg'));
			iconRegistry.addSvgIcon('feedback',sanitizer.bypassSecurityTrustResourceUrl('assets/icon/feedback.svg'));

			//check error path
			if(window.location.pathname==='/error/404' || window.location.pathname==='/error/network') this.router.navigate(['/']);
	}
	ngOnInit(){
    	if(storage.getItem("token")) {
    		this.authenticationService.refreshToken().subscribe(result => {
	        if(result.code === 200){
		        storage.setItem('token', result.data.user.token);
		        this.globals.user = result.data.user;
	          	this.globals.token = result.data.user.token;
	          	this.globals.wid = result.data.user.wid;
	          	this.globals.apiImageEndpoint = result.data.user.cdn;
	        }else{
	        	storage.removeItem('currentUser');
	        	storage.removeItem('uid');
	        	storage.removeItem('token');
	        	this.router.navigate(['/auth/login']);
	        }
        	this.globals.checkingRefreshToken = true;
      	}, error => {
	      	this.authenticationService.logout();
	      	this.globals.checkingRefreshToken = true;
	      	this.router.navigate(['/auth/login']);
	    });
		}else{
    	this.globals.checkingRefreshToken = true;
    }

	}
	onActivated(component) {}
	detectDeviceMode(){
		if(window.innerHeight > window.innerWidth){
		    this.appClass = 'portrait';
		}else{
			this.appClass = 'landscape';
		}
	}
	/*
	*Load Course Information
	*/
	loadCourse(id){
  		this.courseDetaiID = id;
	}


	/*
	*load Course For Elearning with input @elearningEnrollID
	*/
	loadElearning(id){
  	this.elearningEnrollID = id;
	}
	
  @HostListener('window:resize', ['$event'])
	resize($event: any) {
		this.detectDeviceMode();
	}
}
  